import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManagecreditpopupComponent } from './managecreditpopup.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

const routes: Routes = [
  {
      path: '',
      component: ManagecreditpopupComponent,
      data: {
          title: 'Manage Credit'
      }
  }
];
@NgModule({
  declarations: [ManagecreditpopupComponent],
  imports: [
    CommonModule, 
    BrowserModule, 
    ReactiveFormsModule,  
    FormsModule,   
    MatDialogModule,
    NgbModule, 
    RouterModule.forChild(routes)
  ]
})
export class ManagecreditpopupModule { }
